"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _Switcher = _interopRequireWildcard(require("../Switcher/Switcher"));
var _InputWithErrorText = _interopRequireDefault(require("../InputWithError/InputWithErrorText"));
var _Context = require("./Context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ALL_HOTELS_STARS = 1;
var EMAIL_VALIDITY_PATTERN = '[^@\\s]+@[^@\\s]+\\.[^@\\s]+';
var starsList = [{
  id: _Switcher.SELECT_ALL_ID,
  label: _localization.i18n.t('subscribe.edit.rating')
}, {
  id: 3,
  label: '3+'
}, {
  id: 4,
  label: '4+'
}, {
  id: 5,
  label: '5'
}];
var PricewatchSubscribeForm = function PricewatchSubscribeForm() {
  var _useContext = (0, _react.useContext)(_Context.SubscribeContext),
    isMobile = _useContext.isMobile,
    defaultEmail = _useContext.defaultEmail,
    state = _useContext.state,
    STATE = _useContext.STATE,
    email = _useContext.email,
    setEmail = _useContext.setEmail,
    hotelStars = _useContext.hotelStars,
    setHotelStars = _useContext.setHotelStars,
    setSubmitable = _useContext.setSubmitable,
    dataLayerPush = _useContext.dataLayerPush,
    dataLayerPushParams = _useContext.dataLayerPushParams;
  if (state !== STATE.EDIT) return null;
  var isLoggedIn = Boolean(defaultEmail);
  var handleChangeStars = function handleChangeStars(_ref) {
    var id = _ref.id;
    setHotelStars(id === _Switcher.SELECT_ALL_ID ? ALL_HOTELS_STARS : id);
    dataLayerPushParams({
      stars_subscription: id
    });
    dataLayerPush({
      event: 'pricewatch_subscription_form_hotel_stars'
    });
  };
  var handleEmailOnBlur = function handleEmailOnBlur() {
    dataLayerPushParams({
      email_subscription: email
    });
    dataLayerPush({
      event: 'pricewatch_subscription_form_email'
    });
  };
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledFormItem, {
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(StyledLabel, null, t('subscribe.edit.track')), /*#__PURE__*/_react["default"].createElement(StyledSwitcher, {
    list: starsList.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        selected: item.id === hotelStars
      });
    }),
    onChange: handleChangeStars,
    isMobile: isMobile
  })), !isLoggedIn && /*#__PURE__*/_react["default"].createElement(StyledFormItem, {
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(StyledLabel, null, t('subscribe.edit.email')), /*#__PURE__*/_react["default"].createElement(_InputWithErrorText["default"], {
    required: true,
    value: email,
    onChange: setEmail,
    onBlur: handleEmailOnBlur,
    onValidate: setSubmitable,
    placeholder: t('subscribe.edit.input'),
    pattern: EMAIL_VALIDITY_PATTERN,
    isMobile: isMobile,
    errors: {
      empty: '\n',
      invalid: t('subscribe.edit.error')
    }
  })));
};
var StyledSwitcher = (0, _styledComponents["default"])(_Switcher["default"]).withConfig({
  displayName: "PricewatchSubscribeFormEdit__StyledSwitcher",
  componentId: "sc-5fpps6-0"
})(["margin:0;"]);
var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "PricewatchSubscribeFormEdit__StyledLabel",
  componentId: "sc-5fpps6-1"
})(["display:flex;font-size:12px;line-height:16px;font-weight:400;color:var(--grey1);"]);
var StyledFormItem = _styledComponents["default"].div.withConfig({
  displayName: "PricewatchSubscribeFormEdit__StyledFormItem",
  componentId: "sc-5fpps6-2"
})(["width:100%;display:flex;gap:4px;flex-wrap:nowrap;flex-direction:column;", ""], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && (0, _styledComponents.css)(["gap:8px;", "{font-size:16px;line-height:20px;}"], StyledLabel);
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(PricewatchSubscribeForm);